import { render } from "./SubFamilyLearnMoreDialog.vue?vue&type=template&id=69670750&scoped=true"
import script from "./SubFamilyLearnMoreDialog.vue?vue&type=script&lang=js"
export * from "./SubFamilyLearnMoreDialog.vue?vue&type=script&lang=js"

import "./SubFamilyLearnMoreDialog.vue?vue&type=style&index=0&id=69670750&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69670750"]])

export default __exports__